<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-3">
<h1>Chapter 3</h1>
<p>Lorrie made an agreement with his wife. He would only use the money from the sale of his previous business for his new venture. They had to sell some properties in order to build their home for their new life.</p>
<p>Lorrie’s wife was living with her brother in the city, as she worked in the city. Lorrie was living alone on the farm. There was no residence and he had to sleep in his office attached to the restaurant.</p>
<p>Lorrie thought, <em>It may take me one year, two years or three just to clean up this place. Here I am, I believe in this place. If money is not coming in fast, I just have to wait!</em></p>
<p>Lorrie’s hard work started to pay off. The place was slowly recovering from years of disrepair and neglect. However, there were still mice running rampant.</p>
<p>Lorrie’s wife pitied her husband.</p>
<p>“Since you have a problem with unwanted little creatures, I will find you a good cat to look after the place for you,” she promised.</p>
<p>However, it was Lorrie who chose me.</p>
<p>At first, Lorrie was not a cat person. I was a very good hunter. He was enthralled. Slowly, I became Lorrie’s best friend! I followed Lorrie everywhere.</p>
<p>One time, Lorrie was busy slashing the overgrowth, tidying up the forest. I knew something was not quite right with me. Later on, I was very sick and Lorrie’s wife found a few bush ticks over my body. She saved my life!</p>
<p>Growing up in the complex was tough. People came and went every day. People sometimes brought along their pets. Some were savage animals, not too friendly. I soon learned to treat everyone with caution. Luckily, I was tall, with the size of a wild beast. I did have powerful jaws that could crush skulls. Lorrie marvelled that I crouched like a running tiger and lurked by the path like a leopard. However, I was just a cat!</p>
<p>Lorrie said to his friends, “If there is any little wild thing in the unit, it will only take a few minutes for my cat to catch it!”</p>
<p>I was a patient hunter. Sometimes, I would wait half a day for my prey to come out of their hiding place. I often consumed my prey whole. However, I was never a fighter. I had the knowledge of every high and low, nook and corner. In a moment, I could be up on the roof; no one could possibly follow and catch me. I kept my enemies at bay and I was the cool one. Lorrie was proud of me.</p>
<p>Since the bush ticks’ attack, Lorrie checked my body very often. Despite being an outdoor cat, I did not have scars or injuries. Lorrie did not allow me outdoors at night. People just loved to hold me in their arms. However, there were certain people I would not dare to go near them. By their smell, I could tell who was safe and who was dangerous. My instinct told me many things, it kept me safe.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch007.vue?067ae4b3